export default __webpack_public_path__ + "static/media/Glove3.7a2cb7eb.svg";